<template>
  <div class="footer">
    <footer class="bdb-footer">
      <div class="l-center">
        <div class="top flex justify-b items-c">
          <div class="ft-logo">
            <img
              src="@/assets/images/logo/logo_gray.webp"
              alt="바다바 로고"
              class="img"
            />
          </div>
          <!-- <ul class="ft-sns-grp flex justify-s">
            <li class="sns-list type-insta">
              <a
                class="sns-link"
                @click="alert('준비중입니다')"
              />
            </li>
            <li class="sns-list type-fb">
              <a
                class="sns-link"
                @click="alert('준비중입니다')"
              />
            </li>
            <li class="sns-list type-yt">
              <a
                class="sns-link"
                @click="alert('준비중입니다')"
              />
            </li>
          </ul> -->
        </div>
        <div class="middle">
          <span class="txt f-rem12 f-m i-block mb-5"> 대표자: 한재민 </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            사업자명: 주식회사 뉴플로
          </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            사업자 등록번호: 652-81-03262
          </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            주소지: 서울 성동구 왕십리로 125, 6층 622호
          </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            연락처: 010-2276-2216
          </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            업무시간: 10:00 - 19:00
          </span>
          <br />
          <span class="txt f-rem12 f-m i-block mb-5">
            E-mail: badaba@badaba.co
          </span>
        </div>
        <div class="bottom flex justify-c items-c">
          <a
            class="link f-rem12 f-m"
            @click="$router.push({ name: 'StaffTerms', params: { tab: 1 } })"
            >이용약관</a
          >
          <a
            class="link f-rem12 f-m"
            @click="$router.push({ name: 'StaffTerms', params: { tab: 2 } })"
            >개인정보처리방침</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "LayoutFooter",
  data() {
    return {};
  },
};
</script>
